import { useState, useRef, useEffect, useContext } from "react";
import { FaArrowLeft, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router";
import buildLink from "../../../urls";
import { PlaySounds } from "../../../functions/playSounds";
import MessageAlert from "../../../components/messageAlert";
import PointsLoader from "../../../components/PointsLoader";
import ReactPaginate from "react-paginate";
import Select from "react-select";
import { CompanyContext } from "../../../contexts/companyCotext";
import { axiosServer } from "../../../axiosServer";
import Loader from "../../../components/loader";

const ATTRIBUTE_LABELS = {
  width: "Width",
  height: "Height",
  length: "Length",
  weight: "Weight",
};

const getApiPayload = (source) => {
  const candidates = [source?.data?.response, source?.data?.data, source?.data];

  return (
    candidates.find(
      (candidate) =>
        candidate &&
        (typeof candidate.success !== "undefined" ||
          Array.isArray(candidate.errors) ||
          typeof candidate.message === "string"),
    ) ||
    source?.data ||
    {}
  );
};

function LowStockProducts() {
  const history = useNavigate();
  const [stateCom] = useContext(CompanyContext);
  const quantityCheck = useRef();
  const productCheck = useRef();
  const addressCheck = useRef();
  const quantityFound = useRef();
  const changeProductCheck = useRef();
  const oldBinID = useRef();
  const newBinID = useRef();
  const notFoundProduct = useRef();
  const notFoundAddress = useRef();
  const [counter, setCounter] = useState(0);
  const [checkQuantityValue, setCheckQuantityValue] = useState("");
  const [productCheckValue, setProductCheckValue] = useState("");
  const [addressCheckValue, setAddressCheckValue] = useState("");
  const [scanCompleted, setScanCompleted] = useState(false);
  const [changeCounter, setChangeCounter] = useState(0);
  const [changeQuantityValue, setChangeQuantityValue] = useState("");
  const [changeProductCheckValue, setChangeProductCheckValue] = useState("");
  const [oldBinValue, setOldBinValue] = useState("");
  const [newBinValue, setNewBinValue] = useState("");
  const [changeScanCompleted, setChangeScanCompleted] = useState(false);
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [warehouses, setWarehouses] = useState([]);
  const [warehouse_id, setWarehouseID] = useState("");
  const [warehouse_name, setWarehouseName] = useState("");
  const [notFoundWarehouseID, setNotFoundWarehouseID] = useState("");
  const [notFoundWarehouseName, setNotFoundWarehouseName] = useState("");
  const [floor_id, setFloorID] = useState("");
  const [sku, setSKU] = useState("");
  const [quantity, setQuantity] = useState("");
  const [floor_name, setFloorName] = useState("");
  const [notFoundProductValue, setNotFoundProductValue] = useState("");
  const [notFoundAddressValue, setNotFoundAddressValue] = useState("");

  const [floors, setFloors] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [message, setMessage] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [loading, setLoading] = useState(true);
  const host = window.location.host;

  const [show, setShow] = useState(false);
  const [showCheckModal, setShowCheckModal] = useState(false);
  const [showChangeModal, setShowChangeModal] = useState(false);
  const [showNotFoundModal, setShowNotFoundModal] = useState(false);
  const [showDimensionsModal, setShowDimensionsModal] = useState(false);
  const [missingDimensionProducts, setMissingDimensionProducts] = useState([]);
  const [missingDimensionValues, setMissingDimensionValues] = useState({});
  const [pendingLowStockAction, setPendingLowStockAction] = useState(null);
  const [isDimensionsSubmitting, setIsDimensionsSubmitting] = useState(false);

  const [totalPages, setTotalPages] = useState(false);

  const [showMessgErr, setShowErrMessage] = useState("");

  const [showMessgSucc, setShowSuccMessage] = useState("");

  const { playErrorSound, playSuccessSound } = PlaySounds();
  const permissions = JSON.parse(localStorage.getItem("permissions"));

  const canShowNotFoundButton =
    (host.startsWith("localhost") || host === "pda.ishtari.com") &&
    permissions?.pda_low_stock_not_found_modal;

  const getAcceptedScanValues = (product) => {
    const productOptionValueId = product?.product_option_value_id;
    const hasProductOptionValueId =
      productOptionValueId !== "" && productOptionValueId != null;
    const scanValues = [];

    if (hasProductOptionValueId) {
      if (product?.sku) {
        scanValues.push(`${product.sku}-${productOptionValueId}`);
      }

      if (product?.product_id) {
        scanValues.push(`${product.product_id}-${productOptionValueId}`);
      }
    } else {
      scanValues.push(product?.product_id, product?.sku, product?.barcode);
    }

    return scanValues
      .filter((value) => value !== "" && value != null)
      .map((value) => String(value).trim().toLowerCase());
  };

  const getDisplayedScanTarget = (quantityValue) => {
    if (quantityValue.trim() === "") {
      return 0;
    }

    const parsedQuantity = Number(quantityValue);

    if (!Number.isInteger(parsedQuantity) || parsedQuantity < 0) {
      return 0;
    }

    return parsedQuantity > 0 ? parsedQuantity : 0;
  };

  const getProducts = async () => {
    try {
      var path = `&page=${currentPage}`;

      path += `&warehouse_id=${warehouse_id || "7"}`;

      if (floor_id != "") {
        path += `&filter_floor=${floor_id}`;
      }

      if (quantity !== "") {
        path += `&filter_quantity=${quantity}`;
      }

      if (sku !== "") {
        path += `&filter_sku=${sku}`;
      }

      const response = await axiosServer.get(
        buildLink("getLowStockProducts") + path,
      );

      const data = response?.data;

      if (data?.success) {
        if (data?.page == 1 && warehouse_id == "" && floor_id == "") {
          setWarehouses(data?.warehouses);
          setFloors(data?.floors);
        }

        if (
          data?.total_pages > 1 &&
          data?.products &&
          data?.products?.length > 0
        ) {
          setShow(true);
          setTotalPages(data?.total_pages);
          setCurrentPage(data?.page);
        } else {
          setShow(false);
        }
        setLoading(false);
        setProducts(data?.products);
      } else {
        setMessage("No Products Found!");

        playErrorSound();
        setShowErrMessage(true);
        setTimeout(() => setShowErrMessage(false), 3000);

        setLoading(false);
        setProducts([]);
      }
    } catch (e) {
      setMessage(e.response?.data?.message || "Error fetching products");

      playErrorSound();
      setShowErrMessage(true);
      setTimeout(() => setShowErrMessage(false), 3000);

      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    getProducts();
  }, [currentPage, warehouse_id, floor_id]);

  useEffect(() => {
    if (showCheckModal) {
      quantityCheck.current?.focus();
      setCounter(0);
      setCheckQuantityValue("");
      setProductCheckValue("");
      setAddressCheckValue("");
      setScanCompleted(false);
    }
  }, [showCheckModal]);

  useEffect(() => {
    if (showCheckModal && scanCompleted) {
      addressCheck.current?.focus();
    }
  }, [showCheckModal, scanCompleted]);

  useEffect(() => {
    if (showChangeModal) {
      quantityFound.current?.focus();
      setChangeCounter(0);
      setChangeQuantityValue("");
      setChangeProductCheckValue("");
      setOldBinValue("");
      setNewBinValue("");
      setChangeScanCompleted(false);
    }
  }, [showChangeModal]);

  useEffect(() => {
    if (showChangeModal && changeScanCompleted) {
      oldBinID.current?.focus();
    }
  }, [showChangeModal, changeScanCompleted]);

  useEffect(() => {
    if (showNotFoundModal) {
      const defaultWarehouseID = warehouse_id || "7";
      const defaultWarehouse = warehouses.find(
        (warehouse) =>
          String(warehouse?.warehouse_id) === String(defaultWarehouseID),
      );

      setNotFoundWarehouseID(defaultWarehouseID);
      setNotFoundWarehouseName(
        defaultWarehouse?.warehouse_name || warehouse_name || "",
      );
      setNotFoundProductValue("");
      setNotFoundAddressValue("");
      setTimeout(() => {
        notFoundProduct.current?.focus();
      }, 0);
    }
  }, [showNotFoundModal, warehouse_id, warehouse_name, warehouses]);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected + 1);
  };

  const openCheckModal = (product) => {
    setCounter(0);
    setCheckQuantityValue("");
    setProductCheckValue("");
    setAddressCheckValue("");
    setScanCompleted(false);
    setShowCheckModal(true);
    quantityCheck?.current?.focus();
    setSelectedProduct(product);
  };

  const openChangeModal = (product) => {
    setChangeCounter(0);
    setChangeQuantityValue("");
    setChangeProductCheckValue("");
    setOldBinValue("");
    setNewBinValue("");
    setChangeScanCompleted(false);
    setShowChangeModal(true);
    quantityFound?.current?.focus();
    setSelectedProduct(product);
  };

  const openLowStockAction = (e, product, action) => {
    e.preventDefault();

    const badAttributes = Array.isArray(product?.bad_attributes)
      ? product.bad_attributes.filter(Boolean)
      : [];

    if (badAttributes.length === 0) {
      if (action === "check") {
        openCheckModal(product);
      } else {
        openChangeModal(product);
      }
      return;
    }

    openDimensionsModal(
      [{ product_id: product.product_id, attributes: badAttributes }],
      action,
      product,
    );
  };

  const openDimensionsModal = (
    productsWithMissingDimensions,
    action,
    product = null,
  ) => {
    setSelectedProduct(product);
    setPendingLowStockAction(action);
    setMissingDimensionProducts(productsWithMissingDimensions);
    setMissingDimensionValues((currentValues) =>
      productsWithMissingDimensions.reduce(
        (values, currentProduct) => ({
          ...values,
          [currentProduct.product_id]: (currentProduct.attributes ?? []).reduce(
            (attributes, attribute) => ({
              ...attributes,
              [attribute]: currentValues?.[currentProduct.product_id]?.[
                attribute
              ] ?? "",
            }),
            {},
          ),
        }),
        {},
      ),
    );
    setShowDimensionsModal(true);
  };

  const closeDimensionsModal = () => {
    setShowDimensionsModal(false);
    setMissingDimensionProducts([]);
    setMissingDimensionValues({});
    setPendingLowStockAction(null);
    setSelectedProduct(null);
  };

  const handleMissingDimensionChange = (productId, attribute, value) => {
    setMissingDimensionValues((previousValues) => ({
      ...previousValues,
      [productId]: {
        ...previousValues[productId],
        [attribute]: value,
      },
    }));
  };

  const submitMissingDimensions = async () => {
    const productsPayload = [];

    for (const product of missingDimensionProducts) {
      const productPayload = { product_id: product.product_id };

      for (const attribute of product.attributes ?? []) {
        const rawValue = `${missingDimensionValues[product.product_id]?.[attribute] ?? ""}`.trim();
        const parsedValue = Number(rawValue);

        if (!rawValue || Number.isNaN(parsedValue) || parsedValue <= 0) {
          playErrorSound();
          setMessage("Enter all required dimensions and weight");
          setShowErrMessage(true);
          setTimeout(() => setShowErrMessage(false), 3000);
          return;
        }

        productPayload[attribute] = parsedValue;
      }

      productsPayload.push(productPayload);
    }

    setIsDimensionsSubmitting(true);

    try {
      const response = await axiosServer.post(
        buildLink("addJardehMissingDimensions"),
        {
          user_id: stateCom?.userID,
          products: productsPayload,
        },
      );
      const data = getApiPayload(response);

      if (!data?.success) {
        throw new Error(data?.message || "Failed to update product attributes");
      }

      const product = selectedProduct
        ? { ...selectedProduct, bad_attributes: [] }
        : null;
      const action = pendingLowStockAction;
      setShowDimensionsModal(false);
      setMissingDimensionProducts([]);
      setMissingDimensionValues({});
      setPendingLowStockAction(null);
      setProducts((currentProducts) =>
        currentProducts.map((currentProduct) =>
          currentProduct === selectedProduct ? product : currentProduct,
        ),
      );

      if (action === "notFound") {
        await submitNotFoundProduct();
      } else if (action === "check") {
        openCheckModal(product);
      } else {
        openChangeModal(product);
      }
    } catch (error) {
      playErrorSound();
      setMessage(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to update product attributes",
      );
      setShowErrMessage(true);
      setTimeout(() => setShowErrMessage(false), 3000);
    } finally {
      setIsDimensionsSubmitting(false);
    }
  };

  const handleShowNotFoundModal = (e) => {
    e.preventDefault();
    setDisabled(false);
    setShowNotFoundModal(true);
  };

  const handleSKUTrash = (e) => {
    e.preventDefault();
    setSKU("");
  };

  const handleQuantityTrash = (e) => {
    e.preventDefault();
    setQuantity("");
  };

  const getParsedChangeQuantity = () => {
    if (changeQuantityValue.trim() === "") {
      playErrorSound();
      setMessage("Empty Quantity!");
      setShowErrMessage(true);
      setTimeout(() => setShowErrMessage(false), 3000);
      quantityFound.current?.focus();
      return null;
    }

    const parsedQuantity = Number(changeQuantityValue);

    if (!Number.isInteger(parsedQuantity) || parsedQuantity < 0) {
      playErrorSound();
      setMessage("Enter a valid quantity!");
      setShowErrMessage(true);
      setTimeout(() => setShowErrMessage(false), 3000);
      quantityFound.current?.focus();
      return null;
    }

    return parsedQuantity;
  };

  const moveToChangeProductScan = (e) => {
    e.preventDefault();

    const parsedQuantity = getParsedChangeQuantity();

    if (parsedQuantity === null) {
      return;
    }

    if (parsedQuantity === 0) {
      setChangeCounter(0);
      setChangeProductCheckValue("");
      setChangeScanCompleted(true);
      oldBinID.current?.focus();
      return;
    }

    changeProductCheck.current?.focus();
  };

  const handleChangeProductScan = (e) => {
    e.preventDefault();
    const scannedValue = changeProductCheckValue.trim().toLowerCase();
    const acceptedScanValues = getAcceptedScanValues(selectedProduct);

    const parsedQuantity = getParsedChangeQuantity();

    if (parsedQuantity === null) {
      return;
    }

    if (changeScanCompleted) {
      oldBinID.current?.focus();
      return;
    }

    if (scannedValue === "") {
      playErrorSound();
      setMessage("Scan Product!");
      setShowErrMessage(true);
      setTimeout(() => setShowErrMessage(false), 3000);
      changeProductCheck.current?.focus();
      return;
    }

    if (!acceptedScanValues.includes(scannedValue)) {
      playErrorSound();
      setMessage("Scanned product does not match the selected product!");
      setShowErrMessage(true);
      setTimeout(() => setShowErrMessage(false), 3000);
      setChangeProductCheckValue("");
      changeProductCheck.current?.focus();
      return;
    }

    const nextCounter = changeCounter + 1;
    setChangeCounter(nextCounter);
    setChangeProductCheckValue("");

    if (nextCounter < parsedQuantity) {
      changeProductCheck.current?.focus();
      return;
    }

    setChangeScanCompleted(true);
  };

  const newBinNavigate = (e) => {
    e.preventDefault();
    if (oldBinValue.trim() === "") {
      playErrorSound();
      setMessage("Empty Old Address!");
      setShowErrMessage(true);
      setTimeout(() => setShowErrMessage(false), 3000);
      oldBinID.current?.focus();
      return;
    } else {
      newBinID?.current?.focus();
    }
  };

  const closeCheckModal = () => {
    setShowCheckModal(false);
    setSelectedProduct(null);
    setCounter(0);
    setCheckQuantityValue("");
    setProductCheckValue("");
    setAddressCheckValue("");
    setScanCompleted(false);
    setDisabled(false);
  };

  const closeChangeModal = () => {
    setShowChangeModal(false);
    setSelectedProduct(null);
    setChangeCounter(0);
    setChangeQuantityValue("");
    setChangeProductCheckValue("");
    setOldBinValue("");
    setNewBinValue("");
    setChangeScanCompleted(false);
    setDisabled(false);
  };

  const closeNotFoundModal = () => {
    setShowNotFoundModal(false);
    setNotFoundWarehouseID("");
    setNotFoundWarehouseName("");
    setNotFoundProductValue("");
    setNotFoundAddressValue("");
    setDisabled(false);
  };

  const getParsedCheckQuantity = () => {
    if (checkQuantityValue.trim() === "") {
      playErrorSound();
      setMessage("Empty Quantity!");
      setShowErrMessage(true);
      setTimeout(() => setShowErrMessage(false), 3000);
      quantityCheck.current?.focus();
      return null;
    }

    const parsedQuantity = Number(checkQuantityValue);

    if (!Number.isInteger(parsedQuantity) || parsedQuantity < 0) {
      playErrorSound();
      setMessage("Enter a valid quantity!");
      setShowErrMessage(true);
      setTimeout(() => setShowErrMessage(false), 3000);
      quantityCheck.current?.focus();
      return null;
    }

    return parsedQuantity;
  };

  const moveToProductScan = (e) => {
    e.preventDefault();

    const parsedQuantity = getParsedCheckQuantity();

    if (parsedQuantity === null) {
      return;
    }

    if (parsedQuantity === 0) {
      setCounter(0);
      setProductCheckValue("");
      setScanCompleted(true);
      addressCheck.current?.focus();
      return;
    }

    productCheck.current?.focus();
  };

  const handleProductScan = (e) => {
    e.preventDefault();
    const scannedValue = productCheckValue.trim().toLowerCase();
    const acceptedScanValues = getAcceptedScanValues(selectedProduct);

    const parsedQuantity = getParsedCheckQuantity();

    if (parsedQuantity === null) {
      return;
    }

    if (scanCompleted) {
      addressCheck.current?.focus();
      return;
    }

    if (scannedValue === "") {
      playErrorSound();
      setMessage("Scan Product!");
      setShowErrMessage(true);
      setTimeout(() => setShowErrMessage(false), 3000);
      productCheck.current?.focus();
      return;
    }

    if (!acceptedScanValues.includes(scannedValue)) {
      playErrorSound();
      setMessage("Scanned product does not match the selected product!");
      setShowErrMessage(true);
      setTimeout(() => setShowErrMessage(false), 3000);
      setProductCheckValue("");
      productCheck.current?.focus();
      return;
    }

    const nextCounter = counter + 1;
    setCounter(nextCounter);
    setProductCheckValue("");

    if (nextCounter < parsedQuantity) {
      productCheck.current?.focus();
      return;
    }

    setScanCompleted(true);
  };

  const checkProduct = async (e) => {
    e.preventDefault();

    const parsedQuantity = getParsedCheckQuantity();

    if (parsedQuantity === null) {
      return;
    }

    if (parsedQuantity > 0 && (!scanCompleted || counter < parsedQuantity)) {
      playErrorSound();
      setMessage("Complete product scan first!");
      setShowErrMessage(true);
      setTimeout(() => setShowErrMessage(false), 3000);
      productCheck.current?.focus();
      return;
    }

    if (addressCheckValue.trim() === "") {
      playErrorSound();
      setMessage("Empty Address!");
      setShowErrMessage(true);
      setTimeout(() => setShowErrMessage(false), 3000);
      addressCheck.current?.focus();
      return;
    }

    let product_value;
    if (selectedProduct?.entity_type == "product") {
      product_value = selectedProduct?.product_id;
    } else {
      product_value =
        selectedProduct?.product_id +
        "-" +
        selectedProduct?.product_option_value_id;
    }

    try {
      const obj = {
        user_id: stateCom?.userID,
        product: product_value,
        quantity: selectedProduct?.quantity,
        warehouse_id: warehouse_id || "7",
        entity_type: selectedProduct?.entity_type,
        quantity_found: parsedQuantity,
        old_bin_id: addressCheckValue.trim(),
      };
      setDisabled(true);
      setSubmitting(true);
      const response = await axiosServer.post(
        buildLink("checkLowStockProduct"),
        obj,
      );

      const data = response?.data;

      if (data?.success) {
        playSuccessSound();
        setMessage(data?.message);
        setShowSuccMessage(true);
        setTimeout(() => setShowSuccMessage(false), 3000);
        closeCheckModal();
        await getProducts();
      } else {
        playErrorSound();
        setMessage(data?.message);
        setShowErrMessage(true);
        setDisabled(false);
        setTimeout(() => setShowErrMessage(false), 3000);
        setCounter(0);
        setProductCheckValue("");
        setAddressCheckValue("");
        setScanCompleted(false);
        quantityCheck.current?.focus();
      }
    } catch (e) {
      playErrorSound();
      setDisabled(false);
      setMessage(e?.response?.data?.message || "Error Occured!");
      setShowErrMessage(true);
      setTimeout(() => setShowErrMessage(false), 3000);
      setCounter(0);
      setProductCheckValue("");
      setAddressCheckValue("");
      setScanCompleted(false);
      quantityCheck.current?.focus();
    } finally {
      setSubmitting(false);
    }
  };

  const changeProductAddress = async (e) => {
    e.preventDefault();

    const parsedQuantity = getParsedChangeQuantity();

    if (parsedQuantity === null) {
      return;
    }

    if (
      parsedQuantity > 0 &&
      (!changeScanCompleted || changeCounter < parsedQuantity)
    ) {
      playErrorSound();
      setMessage("Complete product scan first!");
      setShowErrMessage(true);
      setTimeout(() => setShowErrMessage(false), 3000);
      changeProductCheck.current?.focus();
      return;
    }

    if (oldBinValue.trim() === "") {
      playErrorSound();
      setMessage("Empty Old Address!");
      setShowErrMessage(true);
      setTimeout(() => setShowErrMessage(false), 3000);
      oldBinID.current?.focus();
      return;
    }

    if (newBinValue.trim() === "") {
      playErrorSound();
      setMessage("Empty New Address!");
      setShowErrMessage(true);
      setTimeout(() => setShowErrMessage(false), 3000);
      newBinID.current?.focus();
      return;
    }

    let product_value;
    if (selectedProduct?.entity_type == "product") {
      product_value = selectedProduct?.product_id;
    } else {
      product_value =
        selectedProduct?.product_id +
        "-" +
        selectedProduct?.product_option_value_id;
    }
    try {
      const obj = {
        user_id: stateCom?.userID,
        old_bin_id: oldBinValue.trim(),
        new_bin_id: newBinValue.trim(),
        product: product_value,
        warehouse_id: warehouse_id || "7",
        quantity: selectedProduct?.quantity,
        entity_type: selectedProduct?.entity_type,
        quantity_found: parsedQuantity,
      };
      setDisabled(true);
      setSubmitting(true);
      const response = await axiosServer.post(
        buildLink("checkLowStockProduct"),
        obj,
      );

      const data = response?.data;

      if (data?.success) {
        playSuccessSound();
        setMessage(data?.message);
        setShowSuccMessage(true);
        setTimeout(() => setShowSuccMessage(false), 5000);
        closeChangeModal();
        await getProducts();
      } else {
        playErrorSound();
        setMessage(data?.message);
        setShowErrMessage(true);
        setDisabled(false);
        setTimeout(() => setShowErrMessage(false), 5000);
        quantityFound.current?.focus();
      }
    } catch (e) {
      playErrorSound();
      setDisabled(false);
      setMessage(e?.response?.data?.message || "Error Occured!");
      setShowErrMessage(true);
      setTimeout(() => setShowErrMessage(false), 5000);
      quantityFound.current?.focus();
    } finally {
      setSubmitting(false);
    }
  };

  const submitNotFoundProduct = async (e) => {
    e?.preventDefault();

    if (notFoundWarehouseID === "") {
      playErrorSound();
      setMessage("Select Warehouse!");
      setShowErrMessage(true);
      setTimeout(() => setShowErrMessage(false), 3000);
      return;
    }

    if (notFoundProductValue.trim() === "") {
      playErrorSound();
      setMessage("Empty Product!");
      setShowErrMessage(true);
      setTimeout(() => setShowErrMessage(false), 3000);
      notFoundProduct.current?.focus();
      return;
    }

    if (notFoundAddressValue.trim() === "") {
      playErrorSound();
      setMessage("Empty Address!");
      setShowErrMessage(true);
      setTimeout(() => setShowErrMessage(false), 3000);
      notFoundAddress.current?.focus();
      return;
    }

    try {
      setDisabled(true);
      setSubmitting(true);

      const response = await axiosServer.post(
        buildLink("checkLowStockProduct"),
        {
          user_id: stateCom?.userID,
          warehouse_id: notFoundWarehouseID,
          warehouse_name: notFoundWarehouseName,
          product: notFoundProductValue.trim(),
          old_bin_id: notFoundAddressValue.trim(),
          quantity_found: 0,
          entity_type: "product",
          is_modal: 1,
        },
      );

      const data = response?.data;

      if (data?.success) {
        playSuccessSound();
        setMessage(data?.message);
        setShowSuccMessage(true);
        setTimeout(() => setShowSuccMessage(false), 3000);
        closeNotFoundModal();
        await getProducts();
      } else if (Array.isArray(data?.errors) && data.errors.length > 0) {
        setDisabled(false);
        setShowNotFoundModal(false);
        openDimensionsModal(data.errors, "notFound");
      } else {
        playErrorSound();
        setMessage(data?.message);
        setShowErrMessage(true);
        setDisabled(false);
        setTimeout(() => setShowErrMessage(false), 3000);
      }
    } catch (e) {
      const responseData = getApiPayload(e?.response);

      if (
        Array.isArray(responseData?.errors) &&
        responseData.errors.length > 0
      ) {
        setDisabled(false);
        setShowNotFoundModal(false);
        openDimensionsModal(responseData.errors, "notFound");
        return;
      }

      playErrorSound();
      setDisabled(false);
      setMessage(responseData?.message || "Error Occured!");
      setShowErrMessage(true);
      setTimeout(() => setShowErrMessage(false), 3000);
    } finally {
      setSubmitting(false);
    }
  };

  const isCheckQuantityZero =
    checkQuantityValue.trim() !== "" && Number(checkQuantityValue) === 0;
  const isChangeQuantityZero =
    changeQuantityValue.trim() !== "" && Number(changeQuantityValue) === 0;

  return (
    <>
      <div className="mb-5 sticky top-0 flex flex-col bg-white z-50">
        <div className="w-full bg-dbase h-16">
          <div className="container px-3 relative flex justify-between w-full text-white h-full">
            <div className="flex gap-7 flex-row justify-start">
              <button onClick={() => history(-1)}>
                <FaArrowLeft />
              </button>
              <h2 className="text-xl my-auto">Low Stock Products</h2>
            </div>

            {canShowNotFoundButton && (
              <div className="flex justify-end mr-3 items-center text-center text-lg">
                <button
                  className="border border-white rounded-md px-2 py-1 bg-white text-dbase"
                  onClick={handleShowNotFoundModal}
                >
                  Not Found
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {!showCheckModal &&
        !showChangeModal &&
        !showNotFoundModal &&
        !showDimensionsModal && (
          <div className="container">
            <div>
              <div>Warehouse</div>
              <Select
                placeholder="Select Warehouse"
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    borderRadius: "7px",
                    borderColor: state.isFocused ? "grey" : "grey",
                    padding: "8px 5px",
                    height: "48px",
                  }),
                }}
                options={warehouses.map((warehouse) => ({
                  value: warehouse.warehouse_id,
                  label: warehouse.warehouse_name,
                }))}
                value={warehouses
                  .map((warehouse) => ({
                    value: warehouse.warehouse_id,
                    label: warehouse.warehouse_name,
                  }))
                  .find((option) => option.value === (warehouse_id || "7"))}
                onChange={(option) => {
                  setWarehouseID(option.value);
                  setWarehouseName(option.label);
                }}
                className="mt-1 mb-3"
              />
            </div>
            <div>Floor</div>
            <Select
              placeholder="Select Floor"
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderRadius: "7px",
                  borderColor: state.isFocused ? "grey" : "grey",
                  padding: "8px 5px",
                  height: "48px",
                }),
              }}
              options={floors.map((floor) => ({
                value: floor.floor_id,
                label: floor.floor_name,
              }))}
              value={floors
                .map((floor) => ({
                  value: floor.floor_id,
                  label: floor.floor_name,
                }))
                .find((option) => option.value === floor_id)}
              onChange={(option) => {
                setFloorID(option.value);
                setFloorName(option.label);
              }}
              className="mt-1 mb-3"
            />
            <div className="relative flex-1">
              <div>SKU</div>
              <input
                type="text"
                className="border border-dblack rounded-lg block p-2 flex-grow text-start w-full h-12 pr-10 mt-1 mb-3"
                placeholder="SKU"
                value={sku}
                onChange={(e) => setSKU(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    getProducts();
                  }
                }}
              />

              <FaTrash
                onClick={(e) => handleSKUTrash(e)}
                className="absolute top-12 transform -translate-y-1/2 right-3 cursor-pointer opacity-20 "
              />
            </div>

            <div className="relative flex-1">
              <div>Quantity</div>
              <input
                type="text"
                className="border border-dblack rounded-lg block p-2 flex-grow text-start w-full h-12 pr-10 mt-1"
                placeholder="Quantity"
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    getProducts();
                  }
                }}
              />

              <FaTrash
                onClick={(e) => handleQuantityTrash(e)}
                className="absolute top-12 transform -translate-y-1/2 right-3 cursor-pointer opacity-20 "
              />
            </div>

            {loading ? (
              <PointsLoader />
            ) : (
              <div className="flex flex-wrap justify-between lg:grid lg:grid-cols-3 lg:gap-4  relative translate-x-7 lg:ml-0">
                {products &&
                  products.map((product, index) => (
                    <>
                      <div key={index} className="w-full">
                        <div className="flex flex-row rounded-lg overflow-hidden w-full sm:w-1/2 lg:w-full mt-3">
                          <div className="flex-shrink-0">
                            <img
                              src={product.image_url}
                              alt={product.sku}
                              className="w-32 h-42 object-cover"
                            />
                          </div>
                          <div className="flex flex-col p-4  gap-1 text-sm flex-grow">
                            {product.product_id && (
                              <p>Product ID: {product.product_id}</p>
                            )}
                            {product.sku && <p>SKU: {product.sku}</p>}
                            {product.barcode && (
                              <p>Barcode: {product.barcode}</p>
                            )}
                            {product.address && (
                              <p>Address: {product.address}</p>
                            )}
                            {product.quantity && (
                              <p className="font-semibold text-dbase">
                                Qty: {product.quantity}
                              </p>
                            )}
                            {product.option_name &&
                              product.option_value_name && (
                                <p>
                                  {product.option_name}:{" "}
                                  {product.option_value_name}
                                </p>
                              )}
                          </div>
                        </div>
                        <div
                          className={`flex mb-3 mt-4 space-x-20 lg:space-x-32 `}
                        >
                          <button
                            className="bg-dgreen text-white rounded-lg px-2 py-1"
                            onClick={(e) =>
                              openLowStockAction(e, product, "check")
                            }
                          >
                            Check
                          </button>

                          <button
                            className="bg-dbase text-white rounded-lg px-2 py-1 whitespace-nowrap"
                            onClick={(e) =>
                              openLowStockAction(e, product, "change")
                            }
                          >
                            Change Address
                          </button>
                        </div>
                      </div>
                    </>
                  ))}
              </div>
            )}
          </div>
        )}

      {showCheckModal && (
        <div className="fixed inset-0 z-50 flex justify-center top-0 bg-dgreySeller min-h-screen w-full bg-opacity-50">
          <div className="w-full  mr-3 mt-3 h-96 rounded-lg bg-white lg:p-6 py-2  shadow-lg">
            <h1 className="text-2xl font-semibold text-center">
              Check Product
            </h1>
            <div className="px-4 py-5">
              <input
                ref={quantityCheck}
                disabled={disabled}
                type="text"
                inputMode="numeric"
                value={checkQuantityValue}
                className="border border-dlabelColor outline-dbase w-full rounded-md p-2"
                placeholder="Enter Product Quantity"
                onChange={(e) => {
                  setCheckQuantityValue(e.target.value);
                  setCounter(0);
                  setProductCheckValue("");
                  setAddressCheckValue("");
                  setScanCompleted(false);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    moveToProductScan(e);
                  }
                }}
              />

              <input
                ref={productCheck}
                disabled={disabled || scanCompleted || isCheckQuantityZero}
                type="text"
                value={productCheckValue}
                className="border border-dlabelColor outline-dbase w-full rounded-md p-2 mt-3"
                placeholder="Scan Product"
                onChange={(e) => setProductCheckValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleProductScan(e);
                  }
                }}
              />

              <input
                ref={addressCheck}
                disabled={disabled || (!scanCompleted && !isCheckQuantityZero)}
                type="text"
                value={addressCheckValue}
                className="border border-dlabelColor outline-dbase w-full rounded-md p-2 mt-3"
                placeholder="Address"
                onChange={(e) => setAddressCheckValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    checkProduct(e);
                  }
                }}
              />

              <p className="mt-3 text-md text-dblack">
                Scanned: {counter}/{getDisplayedScanTarget(checkQuantityValue)}
              </p>
            </div>

            <div className="flex items-center justify-end lg:p-3 mb-2">
              <button
                className="border text-dbase active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mx-auto ease-linear transition-all duration-150"
                type="button"
                onClick={closeCheckModal}
              >
                Cancel
              </button>

              <button
                className="border text-white bg-dbase active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mx-auto ease-linear transition-all duration-150"
                type="button"
                disabled={disabled}
                onClick={(e) => {
                  checkProduct(e);
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {showChangeModal && (
        <div className="fixed inset-0 z-50 flex  justify-center bg-dgreySeller  min-h-screen w-full bg-opacity-50">
          <div className="w-full mt-3 h-96 mr-3 rounded-lg bg-white lg:p-6 py-2 shadow-lg">
            <h1 className="text-2xl font-semibold text-center">
              Check Product
            </h1>
            <div className="px-4 py-5 gap-3 flex flex-col">
              <input
                ref={quantityFound}
                disabled={disabled}
                type="text"
                inputMode="numeric"
                value={changeQuantityValue}
                className="border border-dlabelColor outline-dbase w-full rounded-md p-2"
                placeholder="Enter Product Quantity"
                onChange={(e) => {
                  setChangeQuantityValue(e.target.value);
                  setChangeCounter(0);
                  setChangeProductCheckValue("");
                  setOldBinValue("");
                  setNewBinValue("");
                  setChangeScanCompleted(false);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    moveToChangeProductScan(e);
                  }
                }}
              />

              <input
                ref={changeProductCheck}
                disabled={
                  disabled || changeScanCompleted || isChangeQuantityZero
                }
                type="text"
                value={changeProductCheckValue}
                className="border border-dlabelColor outline-dbase w-full rounded-md p-2"
                placeholder="Scan Product"
                onChange={(e) => setChangeProductCheckValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleChangeProductScan(e);
                  }
                }}
              />

              <input
                ref={oldBinID}
                disabled={
                  disabled || (!changeScanCompleted && !isChangeQuantityZero)
                }
                type="text"
                value={oldBinValue}
                className="border border-dlabelColor outline-dbase w-full rounded-md p-2"
                placeholder="Enter Old Address"
                onChange={(e) => setOldBinValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    newBinNavigate(e);
                  }
                }}
              />

              <input
                ref={newBinID}
                type="text"
                disabled={
                  disabled || (!changeScanCompleted && !isChangeQuantityZero)
                }
                value={newBinValue}
                className="border border-dlabelColor outline-dbase w-full rounded-md p-2"
                placeholder="Enter New Address"
                onChange={(e) => setNewBinValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    changeProductAddress(e);
                  }
                }}
              />

              <p className="text-sm text-dblack">
                Scanned: {changeCounter}/
                {getDisplayedScanTarget(changeQuantityValue)}
              </p>
            </div>

            <div className="flex items-center justify-end lg:p-3 mb-2">
              <button
                className="border text-dbase active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mx-auto ease-linear transition-all duration-150"
                type="button"
                onClick={closeChangeModal}
              >
                Cancel
              </button>

              <button
                className="border text-white bg-dbase active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mx-auto ease-linear transition-all duration-150"
                type="button"
                disabled={disabled}
                onClick={(e) => {
                  changeProductAddress(e);
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {showDimensionsModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-dblackk bg-opacity-50 p-3">
          <div className="relative w-full max-w-3xl md:w-[700px]">
            <div className="flex max-h-[calc(100dvh-1.5rem)] flex-col overflow-hidden rounded-lg bg-white shadow-lg outline-none focus:outline-none">
              <div className="flex shrink-0 items-start justify-between border-b border-solid border-gray-300 p-4 sm:p-5">
                <h3 className="text-2xl font-semibold text-gray-900 sm:text-3xl">
                  Missing Dimensions & Weight
                </h3>
                <button
                  className="ml-auto bg-transparent text-black float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                  onClick={closeDimensionsModal}
                  disabled={isDimensionsSubmitting}
                >
                  ×
                </button>
              </div>

              <div className="min-h-0 flex-auto overflow-y-auto p-4 sm:p-6">
                <div className="flex flex-col gap-4">
                  {missingDimensionProducts.map((product) => (
                    <div
                      key={product.product_id}
                      className="rounded-md border border-dplaceHolder p-4"
                    >
                      <h4 className="font-semibold text-dblack mb-4">
                        Product ID: {product.product_id}
                      </h4>
                      <div className="grid gap-4 md:grid-cols-2">
                        {(product.attributes ?? []).map((attribute) => (
                          <label
                            key={`${product.product_id}-${attribute}`}
                            className="flex flex-col gap-2 text-sm text-dblack"
                          >
                            <span>
                              {ATTRIBUTE_LABELS[attribute] || attribute} *
                            </span>
                            <input
                              type="number"
                              inputMode="decimal"
                              min="0.01"
                              step="any"
                              disabled={isDimensionsSubmitting}
                              value={
                                missingDimensionValues[product.product_id]?.[
                                  attribute
                                ] ?? ""
                              }
                              onChange={(e) =>
                                handleMissingDimensionChange(
                                  product.product_id,
                                  attribute,
                                  e.target.value,
                                )
                              }
                              className="border border-dlabelColor outline-dbase w-full rounded-md py-3 px-2"
                              placeholder={`Enter ${ATTRIBUTE_LABELS[attribute] || attribute}`}
                            />
                          </label>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="flex shrink-0 items-center justify-between border-t border-solid border-dgrey p-4 sm:p-6">
                <button
                  className="text-dbase border rounded font-bold uppercase px-6 py-2 text-sm"
                  type="button"
                  onClick={closeDimensionsModal}
                  disabled={isDimensionsSubmitting}
                >
                  Cancel
                </button>
                <button
                  className="bg-dgreen text-white active:bg-green-600 font-bold uppercase text-sm px-6 py-2.5 rounded shadow"
                  type="button"
                  onClick={submitMissingDimensions}
                  disabled={isDimensionsSubmitting}
                >
                  {isDimensionsSubmitting ? <Loader /> : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showNotFoundModal && (
        <div className="fixed inset-0 z-50 flex justify-center top-0 bg-dgreySeller min-h-screen w-full bg-opacity-50">
          <div className="w-full mr-3 mt-3 rounded-lg bg-white lg:p-6 py-2 shadow-lg max-w-2xl max-h-[28rem]">
            <h1 className="text-2xl font-semibold text-center">Not Found</h1>
            <div className="px-4 py-5 flex flex-col gap-4">
              <Select
                placeholder="Select Warehouse"
                isDisabled={disabled}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    borderRadius: "7px",
                    borderColor: state.isFocused ? "grey" : "grey",
                    padding: "8px 5px",
                    minHeight: "48px",
                  }),
                }}
                options={warehouses.map((warehouse) => ({
                  value: warehouse.warehouse_id,
                  label: warehouse.warehouse_name,
                }))}
                value={warehouses
                  .map((warehouse) => ({
                    value: warehouse.warehouse_id,
                    label: warehouse.warehouse_name,
                  }))
                  .find((option) => option.value === notFoundWarehouseID)}
                onChange={(option) => {
                  setNotFoundWarehouseID(option?.value || "");
                  setNotFoundWarehouseName(option?.label || "");
                }}
              />

              <input
                ref={notFoundProduct}
                disabled={disabled}
                type="text"
                value={notFoundProductValue}
                className="border border-dlabelColor outline-dbase w-full rounded-md p-3"
                placeholder="Enter Product"
                onChange={(e) => setNotFoundProductValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    notFoundAddress.current?.focus();
                  }
                }}
              />

              <input
                ref={notFoundAddress}
                disabled={disabled}
                type="text"
                value={notFoundAddressValue}
                className="border border-dlabelColor outline-dbase w-full rounded-md p-3"
                placeholder="Enter Address"
                onChange={(e) => setNotFoundAddressValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    submitNotFoundProduct(e);
                  }
                }}
              />
            </div>

            <div className="flex items-center justify-end lg:p-3 mb-2">
              <button
                className="border text-dbase active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mx-auto ease-linear transition-all duration-150"
                type="button"
                onClick={closeNotFoundModal}
              >
                Cancel
              </button>

              <button
                className="border text-white bg-dbase active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mx-auto ease-linear transition-all duration-150"
                type="button"
                disabled={disabled}
                onClick={(e) => {
                  submitNotFoundProduct(e);
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {show &&
        !loading &&
        !showChangeModal &&
        !showCheckModal &&
        !showNotFoundModal &&
        !showDimensionsModal && (
          <ReactPaginate
            className={"category-pagination"}
            pageCount={totalPages}
            pageRangeDisplayed={1}
            marginPagesDisplayed={1}
            onPageChange={handlePageChange}
            containerClassName={"pagination-buttons"}
            subContainerClassName={"pages pagination"}
            activeClassName={
              "bg-dbase bg-opacity-40  border border-none rounded-lg text-white"
            }
            nextLabel=">"
            previousLabel="<"
            breakLabel="..."
            forcePage={currentPage - 1}
            renderOnZeroPageCount={null}
          />
        )}

      {submitting && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-dgreySeller bg-opacity-50">
          <PointsLoader />
        </div>
      )}

      <MessageAlert
        message={message}
        type={showMessgErr ? "err" : "succ"}
        showMessg={showMessgErr || (showMessgSucc && true)}
      />
    </>
  );
}

export default LowStockProducts;
